import { datadogLogs } from '@datadog/browser-logs';

import { config } from '../config';

const {
  datadog: {
    logs: {
      clientToken,
      service = 'tv-admin',
      env = 'development',
      version,
      level,
    },
  },
} = config;

if (config.datadog.logs.enabled) {
  datadogLogs.init({
    clientToken,
    service,
    env,
    version,
    site: 'datadoghq.eu',
  });
  datadogLogs.logger.setLevel(level);
}

export { datadogLogs };
